/* jshint esversion: 6 */
import 'arrive';
import $ from 'jquery';

import {Loader as GoogleMapsLoader} from 'google-maps';
import GoogleMapsStyles from '../imports/gmaps-styles.js';



document.arrive('.block-gmaps', {existing: true}, function(){
    const blockName = '.block-gmaps';
    const mapElement = this.querySelector(`${blockName}__map`);
    let map = null;
    const loader = new GoogleMapsLoader('AIzaSyABb9a0e_98vKXYh0GUCcbCIEO1piyaKkk', {});
    loader.load().then(function (google) {

        //map
        map = new google.maps.Map(mapElement, {
            center: {
                lat: 45.54484431946534,
                lng: 11.545123298452985
            },
            zoom: 12,
            zoomControl: false,
            scaleControl: false,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            rotateControl: false
        });
        map.setOptions({styles: GoogleMapsStyles});

        const marker = new google.maps.Marker({
            map,
            // icon: this.args.marker.icon + el.type + '.png',
            position: {
                lat: 45.54484431946534,
                lng: 11.545123298452985
            }
        });
    });
});